/* eslint-disable */

import { CmsComponentMapping, CmsDefaultComponent } from '@domgen/dgx-fe-cms';
import { ERROR_CMS_COMPONENT_MAPPING } from '@error/shell';
import { ApplianceDetailsComponent } from '@self-fix/feature-appliance-details';
import { ArticleComponent } from '@self-fix/feature-article';
import { ArticleSearchComponent } from '@self-fix/feature-article-search';
import { YourApplianceComponent } from '@self-fix/feature-your-appliance';
import {
  SmartFixCustomProgressStepperComponent,
  SmartFixCustomVideoBlockComponent,
} from '@self-fix/feature-components';

export const SELF_FIX_CMS_COMPONENT_MAPPING: CmsComponentMapping = {
  'dgx-self-fix:pages/self-fix-application': CmsDefaultComponent,
  'dgx-self-fix:pages/appliance-details': ApplianceDetailsComponent,
  'dgx-self-fix:pages/self-fix-search': ArticleSearchComponent,
  'dgx-self-fix:pages/self-fix-category': ArticleSearchComponent,
  'dgx-self-fix:pages/self-fix-article': ArticleComponent,
  'dgx-self-fix:pages/self-fix-your-appliance': YourApplianceComponent,
  'dgx-self-fix:components/progress-stepper':
    SmartFixCustomProgressStepperComponent,
  'dgx-shared:components/content/video-block':
    SmartFixCustomVideoBlockComponent,
  ...ERROR_CMS_COMPONENT_MAPPING,
};
